export const colors = {
  primary: '#0047ba',
  secondary: '#fff',
  light: '#F9FAFB',
  dark: '#272b30',
  gray: '#6b7280',
}
